'use strict';

const d3=require('d3');
const _=require('pulsar-utils/dist-es6/_');
const StatisticsPanelHelpers=require('../../../../../dist-es6/client/directives/statisticsPanels/statisticsPanelHelpers');
const BaseTwoAxisGraphPanelDirective=require('../../../../../dist-es6/client/directives/statisticsPanels/baseTwoAxisGraphPanelDirective');
const BaseTwoAxisGraphPanelDirectiveController=BaseTwoAxisGraphPanelDirective.DirectiveController;let

TotalIncidentsGraphPanelDirective=class TotalIncidentsGraphPanelDirective extends BaseTwoAxisGraphPanelDirective{
get controller(){return TotalIncidentsGraphPanelDirectiveController}};


const MaxNumTicks=5;
const BarWidth=16;let

TotalIncidentsGraphPanelDirectiveController=class TotalIncidentsGraphPanelDirectiveController extends BaseTwoAxisGraphPanelDirectiveController{
constructor($scope,$timeout,$element,elementService){
super($scope,$timeout,$element,elementService);

this._drawTickLinesOnTopOfGraph=!0;
this._allMonthBucketsForBackground=d3.time.month.utc.range(this.graphXAxisDomain[0],this.graphXAxisDomain[1]);
}


_setupGraphs(){
if(!_.exists(this._backgroundBarGroup)){
this._backgroundBarGroup=this._svgContainer.
insert('g','.graph-area').
attr({
class:'background-bars',
transform:`translate(${this._axisLabelMargins.left},${this._axisLabelMargins.top})`});

}

this._numYAxisTicks=Math.min(this.graphYAxisDomain[1],MaxNumTicks);
}






_getAggregateBucketViewData(monthViewData){
const getOnScreenHeight=this._yScale.copy().rangeRound(this._yScale.range().reverse());

return _(monthViewData).keys().map(monthName=>{
const x=this._xScale(monthViewData[monthName].monthStart);
const heightBelow=getOnScreenHeight(monthViewData[monthName].Below+monthViewData[monthName].NotApplicable);
const heightAt=getOnScreenHeight(monthViewData[monthName].At);
const heightAbove=getOnScreenHeight(monthViewData[monthName].Above);

return[{
x,
height:heightAbove,
y:this.graphAreaDimensions.height-heightAbove,
class:'above-threshold',
id:`${monthName}_0`},
{
x,
height:heightAt,
y:this.graphAreaDimensions.height-(heightAt+heightAbove),
class:'at-threshold',
id:`${monthName}_1`},
{
x,
height:heightBelow,
y:this.graphAreaDimensions.height-(heightBelow+heightAt+heightAbove),
id:`${monthName}_2`}];

}).flatten().value();
}

get barWidth(){
return BarWidth;
}

_setupInitialState(){

const aggregateBucketViewData=this._getAggregateBucketViewData(this.context);

this._backgroundBars=this._backgroundBarGroup.
selectAll('rect').
data(this._allMonthBucketsForBackground,d=>d.getTime());

this._backgroundBars.
enter().
append('rect').
attr({
width:this.barWidth,
y:0,
height:this.graphAreaDimensions.height});


this._backgroundBars.
exit().
remove();

this._aggregateBars=this._graphAreaGroup.
selectAll('rect').
data(aggregateBucketViewData,d=>d.id);

this._aggregateBars.
enter().
append('rect').
attr({
width:this.barWidth,
y:this.graphAreaDimensions.height,
fill:`url(#gradient-${this.panelId})`,
"clip-path":`url(#clip-path-${this.panelId})`});


this._aggregateBars.
exit().
remove();

this._yAxisGroup.classed({
y:!0,
axis:!0});

}


_updateState(isResizing){
const noAnimations=this.preventAnimations||isResizing;

const backgroundBarsWithOrWithoutTransition=noAnimations?
this._backgroundBars:
this._backgroundBars.transition().duration(StatisticsPanelHelpers.DefaultTransitionDuration);

backgroundBarsWithOrWithoutTransition.
attr({
x:d=>this._xScale(d)-this.barWidth/2,
width:this.barWidth,
height:this.graphAreaDimensions.height});


const barsWithOrWithoutTransition=noAnimations?
this._aggregateBars:
this._aggregateBars.transition().duration(StatisticsPanelHelpers.DefaultTransitionDuration);

barsWithOrWithoutTransition.
attr({
width:this.barWidth,
height:b=>b.height,
y:b=>b.y,
x:b=>b.x-this.barWidth/2,
class:b=>b.class});

}};






module.exports=TotalIncidentsGraphPanelDirective;
//# sourceMappingURL=totalIncidentsGraphPanelDirective.js.map
